import styled from "styled-components";
import Heading from "@vfuk/core-heading";
import InitialsAvatar from "@vfuk/core-initials-avatar";
import SimpleGrid from "@vfuk/core-simple-grid";
import Span from "@vfuk/core-span";
import Paragraph from "@vfuk/core-paragraph";

const AlignedDiv = styled.div`
  display: inline-block;
  text-align: left;
`;

const CenteredDiv = styled.div`
  text-align: center;
  vertical-align: middle;
`;

const Greetings = ({
  name,
  email,
  initials,
  role,
}: {
  name: string | undefined;
  email: string | undefined;
  initials: string;
  role?: string | undefined;
}) => {
  return (
    <SimpleGrid columns={{ sm: 6 }} spacing={3} verticalAlign="center">
      <CenteredDiv>
        <InitialsAvatar initials={initials} size={3} />
      </CenteredDiv>
      <AlignedDiv>
        <Heading
          size={2}
          level={3}
          justify="left"
          text={`Hello, ${name}!`}
          noMargin
        />
        <Paragraph noMargin>{email}</Paragraph>
        {role && <Span>{role}</Span>}
      </AlignedDiv>
    </SimpleGrid>
  );
};

export default Greetings;
